import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession, useTranslation } from '@/contexts';
import { ROUTES } from '@/constants/routes';
import styles from './SessionGate.module.css';

interface SessionGateProps {
  children: ReactNode;
}

export function SessionGate({ children }: SessionGateProps) {
  const { status, isAuthenticated } = useSession();
  const { t } = useTranslation();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className={styles.loadingScreen}>
        <p className={styles.loadingText}>{t('auth.sessionLoading')}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location.pathname }} />;
  }

  return children;
}
